
import { computed, defineComponent } from 'vue';
import { formatSecond } from '@utiles/index';
export default defineComponent({
  name: 'ArticleCountDown',
  props: {
    countdownSecond: {
      required: false,
      default: 0,
    },
  },
  setup(props: any) {
    const LeftTime = computed(() => {
      return formatSecond(props.countdownSecond);
    });

    return {
      LeftTime,
    };
  },
});
